import {existingCustomerSelected, queryBearerToken} from "./UserAuthentication";
import {queryArticleOptionData} from "./ArticleData";
import {agencyServerArticleNumber, agencyServerCMSArticles, agencyServerProjectArticles, cmsArticles, devProjectArticleNumber, shopArticles} from "../config/Config";
import {appInitialized} from "./AppInit";
import {putFormData} from "./FormData";
import {ARTICLE_TYPE_CMS, ARTICLE_TYPE_SHOP, PROJECT_STATE_DEV, PROJECT_STATE_LIVE} from "../constants/General";
import {queryCustomerAccounts} from "./Accounts";
import {_contract, _customerNumber} from "../selectors/GetParam";
import {queryNewCart} from "./Cart";
import {PRODUCT_CHANGE} from "../constants/StepLabels";
import {queryCustomerResellers} from "./Resellers";
import {queryCustomerContracts} from "./Contracts";
import {getContracts} from "../selectors/SimpleSelectors";
import {delve} from "../util/util";
import {activateBaseArticle, selectBaseArticle, selectCurrentProduct} from "./BaseArticle";
import {initialize as initializeForms} from "redux-form";
import {queryAddInitialProject} from "./ProjectSelection";
import {selectCartProperty} from "./Properties";
import {getContractBillingPeriodNormalized} from "../selectors/Contract";

export const initializeAppProductChange = (initParams) => (dispatch, getState) => {

    const articleDataToLoad = [
        agencyServerArticleNumber,
        ...cmsArticles,
        ...shopArticles,
        ...agencyServerProjectArticles
    ]

    Promise.all([

        dispatch(queryBearerToken())

    ]).then(args => {

        Promise.all([

            dispatch(queryNewCart()),
            dispatch(queryCustomerAccounts(_customerNumber)),
            dispatch(queryCustomerContracts(_customerNumber)),
            dispatch(queryCustomerResellers(_customerNumber))

        ]).then(args => {

            const contracts = getContracts(getState())
            const contract = contracts[_contract]
            const currentArticle = "" + delve(contract, "article.articleNumber")
            const currentSourceAccount = delve(getState(), "accounts." + contract.sourceUid);
            const postInitCalls = []

            postInitCalls.push(existingCustomerSelected())

            if (articleDataToLoad.indexOf('' + currentArticle) === -1) {
                articleDataToLoad.push('' + currentArticle);
            }

            const billingPeriodStart = getContractBillingPeriodNormalized(getState());

            postInitCalls.push(selectCartProperty('billingPeriod', billingPeriodStart));

            if (currentSourceAccount && currentSourceAccount.backupRange) {
                postInitCalls.push(selectCartProperty('backupRange', currentSourceAccount.backupRange));
            }

            postInitCalls.push(queryArticleOptionData(articleDataToLoad))

            Promise.all(postInitCalls.map(func => dispatch(func))).then(args => {

                // dispatch initial toggle selections depending on account / contract

                if (contract.sourceType === "ACCOUNT") {

                    if (cmsArticles.indexOf(currentArticle) >= 0) {

                        dispatch(selectCurrentProduct(currentArticle, contract.sourceUid))
                        dispatch(selectBaseArticle(currentArticle))

                        dispatch(initializeForms('projectSelection',
                            {
                                article: currentArticle,
                                storage: "",
                                state: PROJECT_STATE_LIVE,
                                backup: currentSourceAccount.backupRange || 7,
                                type: ARTICLE_TYPE_CMS
                            }
                        ))
                        dispatch(appInitialized({...initParams, initialStep: PRODUCT_CHANGE}))
                        dispatch(putFormData());

                    } else if (shopArticles.indexOf(currentArticle) >= 0) {

                        dispatch(selectCurrentProduct(currentArticle, contract.sourceUid))
                        dispatch(selectBaseArticle(currentArticle))

                        dispatch(initializeForms('projectSelection',
                            {
                                article: currentArticle,
                                storage: "",
                                state: PROJECT_STATE_LIVE,
                                backup: currentSourceAccount.backupRange || 7,
                                type: ARTICLE_TYPE_SHOP
                            }
                        ))

                        dispatch(appInitialized({...initParams, initialStep: PRODUCT_CHANGE}))
                        dispatch(putFormData());

                    } else if (agencyServerProjectArticles.indexOf(currentArticle) >= 0) {

                        dispatch(selectCurrentProduct(currentArticle, contract.sourceUid))
                        dispatch(selectBaseArticle(currentArticle))

                        dispatch(initializeForms('projectSelection',
                            {
                                article: currentArticle,
                                storage: "",
                                state: currentArticle === devProjectArticleNumber ? PROJECT_STATE_DEV : PROJECT_STATE_LIVE,
                                backup: currentSourceAccount.backupRange || 7,
                                type: agencyServerCMSArticles.indexOf(currentArticle) >= 0 ? ARTICLE_TYPE_CMS : ARTICLE_TYPE_SHOP
                            }
                        ))


                        dispatch(appInitialized({...initParams, initialStep: PRODUCT_CHANGE}))
                        dispatch(putFormData());

                    } else {

                        // old article, like Webhosting L 10.0
                        dispatch(selectCurrentProduct(currentArticle, contract.sourceUid))

                        dispatch(initializeForms('projectSelection',
                            {
                                article: cmsArticles[2],
                                storage: "",
                                state: PROJECT_STATE_LIVE,
                                backup: currentSourceAccount.backupRange || 7,
                                type: ARTICLE_TYPE_CMS
                            }
                        ))

                        dispatch(queryAddInitialProject(true)).then((args) =>{
                            dispatch(appInitialized({...initParams, initialStep: PRODUCT_CHANGE}))
                            dispatch(putFormData());
                        })
                    }

                } else if (contract.sourceType === "RESELLER") {

                    if("" + currentArticle === agencyServerArticleNumber) {

                        // never happens?
                        dispatch(selectCurrentProduct(currentArticle, contract.sourceUid))
                        dispatch(selectBaseArticle(agencyServerArticleNumber))
                        dispatch(appInitialized({...initParams, initialStep: PRODUCT_CHANGE}))

                        dispatch(putFormData());

                    } else {

                        dispatch(selectCurrentProduct(currentArticle, contract.sourceUid))

                        dispatch(activateBaseArticle(agencyServerArticleNumber, true)).then(() => {
                            dispatch(appInitialized({...initParams, initialStep: PRODUCT_CHANGE}))
                            dispatch(putFormData());
                        })

                    }
                }
            })

        });
    })
}



/** WEBPACK FOOTER **
 ** ./src/actions/AppInit.ProductChange.js
 **/